import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/userSlice';
import HopthruLogo from '../HopthruLogo';
import { AppBar, Box, Divider, Toolbar } from '@mui/material';
import PrivacySelectorButton from '../PrivacySelectorButton';
import FavoriteButton from '../FavoriteButton';
import UserMenuButton from '../UserMenuButton';
import NotificationButton from '../NotificationButton';
import ViewModeToggleButton from '../ViewModeToggleButton';
import HopviewButton from '../HopviewButton';
import ViewName from '../ViewName';
import GlobalSearch from '../GlobalSearch';
import {
  useFeatureEnabled,
  KNOWN_FEATURES,
} from '../../context/FeatureProvider';

export default function HeaderV2() {
  const isDetailView = useRouteMatch([
    '/routes',
    '/trips',
    '/stops',
    '/system',
    '/insights:id',
    '/views/:id',
  ]);
  const isAllView = useRouteMatch({ path: '/views/all', exact: true });
  const isSettings = useRouteMatch('/settings');

  const showViewControls = !!isDetailView && !isAllView;

  const showGlobalSearch = useFeatureEnabled(KNOWN_FEATURES.SHOW_GLOBAL_SEARCH);
  const { isStaff } = useSelector(selectUser);

  return (
    <AppBar
      position='relative'
      sx={(theme) => ({
        color: 'primary.main',
        backgroundColor: 'tertiary.light',
        height: theme.spacing(5),
        paddingTop: 0,
        paddingBottom: 0,
        boxShadow: 'none',
        borderBottom: '1px solid',
        borderColor: 'tertiary.main',
      })}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: {
            xs: 40,
          },
          paddingLeft: 2,
          paddingRight: 2,
        }}
      >
        <Box
          display='flex'
          alignItems='center'
          justifyContent='flex-start'
          flexGrow={1}
          flexBasis={0}
          minWidth={0}
        >
          <HopthruLogo size={32} />
          <Divider
            orientation='vertical'
            flexItem
            sx={{
              marginLeft: 2,
            }}
          />
          {isSettings && (
            <Box
              sx={{
                color: 'secondary.main',
                fontWeight: 500,
                fontSize: '1rem',
                marginLeft: 2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              Settings
            </Box>
          )}
          {isAllView && (
            <Box
              sx={{
                color: 'secondary.main',
                fontWeight: 500,
                fontSize: '1rem',
                marginLeft: 2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              All reports
            </Box>
          )}
          {showViewControls && (
            <>
              <FavoriteButton />
              <PrivacySelectorButton />
              <Box mx={1} width='100%' minWidth={0}>
                <ViewName />
              </Box>
            </>
          )}
        </Box>
        {showGlobalSearch && <GlobalSearch />}
        <Box
          display='flex'
          alignItems='center'
          justifyContent='flex-end'
          flexGrow={1}
          flexBasis={0}
          minWidth={0}
        >
          {showViewControls && <ViewModeToggleButton />}
          {isStaff && <HopviewButton />}
          <NotificationButton useV2 />
          <UserMenuButton useV2 />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
